














































































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";
import { AbiItem } from "web3-utils";
import dxsalePresaleContractABI from "../assets/dxsalePresaleContractABI.json";
import BEP20ContractABI from "../assets/BEP20ContractABI.json";

export default Vue.extend({
  name: "DxsaleDisableWhitelistMonitor",

  data: () => ({
    dialog: false as boolean,
    isStarted: false as boolean,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    presaleAddress: "" as string,
    error: "" as string,
    tokenAddress: " " as string,
    tokenAddressLink: "" as string,
    tokenName: " " as string,
    tokenOwner: " " as string,
    tokenOwnerAddressLink: "" as string,
    foundTime: " " as string,
    transactionHash: " " as string,
    transactionHashLink: "" as string,
    interval: undefined as undefined | SetIntervalAsyncTimer,
    // pollingTime: 1000 as number,
    isProcessing: false,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.error = "";
        this.tokenAddress = " ";
        this.tokenAddressLink = "";
        this.tokenName = " ";
        this.tokenOwner = " ";
        this.tokenOwnerAddressLink = "";
        this.transactionHash = " ";
        this.transactionHashLink = "";
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        return;
      }

      this.error = "";
      this.tokenAddress = " ";
      this.tokenAddressLink = "";
      this.tokenName = " ";
      this.tokenOwner = " ";
      this.tokenAddressLink = "";
      this.foundTime = " ";
      this.transactionHash = " ";
      this.transactionHashLink = "";

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));
      web3.extend({
        property: "txpool",
        methods: [
          {
            name: "content",
            call: "txpool_content",
          },
        ],
      });

      try {
        const presaleContractAbi = dxsalePresaleContractABI as any as AbiItem;
        const presaleContract = new web3.eth.Contract(presaleContractAbi, Web3.utils.toChecksumAddress(this.presaleAddress));

        // token 情報の設定
        const results = await Promise.all([presaleContract.methods.token().call(), presaleContract.methods.wallet().call()]);
        this.tokenAddress = Web3.utils.toChecksumAddress(results[0]);
        this.tokenAddressLink = `https://bscscan.com/address/${this.tokenAddress}`;
        this.tokenOwner = Web3.utils.toChecksumAddress(results[1]);
        this.tokenOwnerAddressLink = `https://bscscan.com/address/${this.tokenOwner}`;
        const tokenContractAbi = BEP20ContractABI as any as AbiItem;
        const tokenContract = new web3.eth.Contract(tokenContractAbi, this.tokenAddress);
        this.tokenName = await tokenContract.methods.name().call();
      } catch (error) {
        // console.error(error);
        this.error = "Address is not PresaleAddress";
        return;
      }

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";
      // this.isProcessing = false;

      // transaction の監視を開始
      // let previousBlockNumber = 0;
      const checkedTransactionHashs: string[] = [];
      this.interval = setIntervalAsync(async () => {
        const result = await (web3 as any).txpool.content();
        const pendingTransactions: any[] = Object.values(result.pending);
        outerLoop: for (const pendingTransaction of pendingTransactions) {
          const transactions: any[] = Object.values(pendingTransaction);
          for (const transaction of transactions) {
            if (transaction == null || checkedTransactionHashs.includes(transaction.hash)) {
              continue;
            }
            if (
              transaction.from == this.tokenOwner.toLowerCase() &&
              transaction.to == "0xbaCEbAd5993a19c7188Db1cC8D0F748C9Af1689A".toLowerCase() &&
              transaction.input == "0xd6b0f484"
            ) {
              this.foundTime = `${moment().format("YYYY/MM/DD HH:mm:ss")}`;
              this.transactionHash = transaction.hash;
              this.transactionHashLink = `https://bscscan.com/tx/${this.transactionHash}`;

              this.btnColor = "primary";
              this.btnText = "Start";
              this.isStarted = false;
              this.dialog = true;

              if (this.interval != undefined) {
                await clearIntervalAsync(this.interval);
              }

              break outerLoop;
            }
          }
        }
        if (checkedTransactionHashs.length > 20000) {
          const deleteCount = checkedTransactionHashs.length - 20000;
          checkedTransactionHashs.splice(0, deleteCount);
        }
      }, 10);
      /*
      this.interval = window.setInterval(async () => {
        if (this.isProcessing != true) {
          const start = performance.now();
          this.isProcessing = true;
          const currentBlockNumber = await web3.eth.getBlockNumber();
          if (currentBlockNumber > previousBlockNumber) {
            // clear checked transaction array.
            checkedTransactionHashs.splice(0);
            previousBlockNumber = currentBlockNumber;
          }
          const result = await (web3 as any).txpool.content();
          const a = performance.now();
          const pendingTransactions: any[] = Object.values(result.pending);
          const b = performance.now();
          console.log(b - a);
          pendingTransactions.some((pendingTransaction) => {
            const transactions: any[] = Object.values(pendingTransaction);
            return transactions
              .filter((transaction) => !checkedTransactionHashs.includes(transaction.hash))
              .some((transaction) => {
                checkedTransactionHashs.push(transaction.hash);
                if (
                  transaction != null &&
                  transaction.from == this.tokenOwner.toLowerCase() &&
                  transaction.to == "0xbaCEbAd5993a19c7188Db1cC8D0F748C9Af1689A".toLowerCase() &&
                  transaction.input == "0xd6b0f484"
                ) {
                  console.log(transaction.from);
                  this.foundTime = `${moment().format("YYYY/MM/DD HH:mm:ss")}`;
                  this.transactionHash = transaction.hash;
                  this.transactionHashLink = `https://bscscan.com/tx/${this.transactionHash}`;

                  clearInterval(this.interval);
                  this.btnColor = "primary";
                  this.btnText = "Start";
                  this.isStarted = false;
                  this.dialog = true;

                  return true;
                }

                return false;
              });
          });
          this.isProcessing = false;
          // console.log(`${moment().format("YYYY/MM/DD HH:mm:ss")}: BlockNumber: ${currentBlockNumber}, CheckedTransaction: ${checkedTransactionHashs.length}`);
          const end = performance.now();
          console.log(`time: ${end - start}`);
        }
      }, this.pollingTime);
      */
    },
  },
  watch: {
    presaleAddress: async function (value: string) {
      if (value == null) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        this.dialog = false;
        this.error = "";
        this.tokenAddress = " ";
        this.tokenAddressLink = "";
        this.tokenName = " ";
        this.tokenOwnerAddressLink = "";
        this.tokenOwner = " ";
        this.foundTime = " ";
        this.transactionHash = " ";
        this.transactionHashLink = "";
      }
    },
  },
});
